// Fix vị trí bottom nav trên mobile
function updateBottomNavPosition() {
    if (window.innerWidth > 768) return;
    var $nav = $('#libraryMainsite-t-float_bottom');
    if (!$nav.length) return;
    var scaleRatio = window.innerWidth / 768;
    var visibleHeightInDesignSpace = window.innerHeight / scaleRatio;
    var navHeight = $nav.outerHeight() || 52;
    $nav.css('top', Math.round(visibleHeightInDesignSpace - navHeight) + 'px');
}

$(window).on('load resize orientationchange', updateBottomNavPosition);

$(function () {
    var $links = $('.list-items a');
    if (!$links.length) return;

    var $allSections = $links.map(function () {
        var href = $(this).attr('href');
        return href && href !== '#' ? $(href)[0] : null;
    }).filter(function () { return this != null; });

    var $container = null;

    function isPC() {
        return window.innerWidth > 768;
    }

    function getScaleRatio() {
        var designW = (typeof varMS !== 'undefined' && varMS.scaleWidthPC) ? varMS.scaleWidthPC : 2000;
        return window.innerWidth / designW;
    }

    function updateScrollability(targetId) {
        if (!$container) return;
        var $section = $(targetId);
        if (!$section.length) return;

        var scale = getScaleRatio();
        var sectionDesignH = $section.parent().outerHeight();
        var viewportDesignH = window.innerHeight / scale;

        if (sectionDesignH > viewportDesignH) {
            $('html').css('overflow-y', 'auto');
            $container.css('min-height', sectionDesignH + 'px');
        } else {
            $('html').css('overflow-y', '');
            $container.css('min-height', '');
            window.scrollTo(0, 0);
        }
    }

    function switchTab(targetId) {
        $links.removeClass('active');
        $links.filter('[href="' + targetId + '"]').addClass('active');
        $allSections.each(function () {
            if ('#' + this.id === targetId) {
                $(this).parent().removeClass('tab-hidden');
            } else {
                $(this).parent().addClass('tab-hidden');
            }
        });
        updateScrollability(targetId);
    }

    $(window).on('load', function () {
        if (!isPC()) return;

        $container = $($allSections[0]).parent().parent();
        $container.css('position', 'relative');

        $allSections.each(function (i) {
            $(this).parent().addClass('tab-wrapper'); // tất cả: để có transition đồng đều
            if (i > 0) {
                $(this).parent().addClass('tab-slide'); // sections 2+: overlay
            }
        });

        // Xóa handler của library, thay bằng handler của mình (PC only)
        $links.off('click').on('click', function (e) {
            e.preventDefault();
            switchTab($(this).attr('href'));
        });

        switchTab($links.first().attr('href'));
    });
});
